import app from 'flarum/forum/app';

/** Same shape the server accepts when it parses mentions out of a story. */
// Non-capturing group kullanıldı: match[1] doğrudan kullanıcı adını verir.
const MENTION = /(?:^|[^\w@])@([a-zA-Z0-9_-]{1,30})/g;

/**
 * Turn story text into vnodes, with @mentions as links to profiles.
 *
 * The text is split and rebuilt as vnodes rather than injected as HTML:
 * story content is user input, and m.trust() on it would be an XSS hole.
 *
 * @param {string} content
 * @param {Function} [onnavigate] called before following a link, so a viewer
 *   can close itself first
 * @returns {Array} vnodes for the story body
 */
export default function renderMentions(content, onnavigate) {
  const text = content || '';
  const nodes = [];

  let last = 0;
  let match;

  MENTION.lastIndex = 0;

  while ((match = MENTION.exec(text)) !== null) {
    // Eşleşmenin başındaki karakter @ değilse (yani bir prefix/boşluk/parantez varsa)
    const hasPrefix = match[0].charAt(0) !== '@';
    const mentionIndex = hasPrefix ? match.index + 1 : match.index;

    if (mentionIndex > last) {
      nodes.push(text.slice(last, mentionIndex));
    }

    nodes.push(mentionLink(match[1], onnavigate));
    last = match.index + match[0].length;
  }

  if (last < text.length) {
    nodes.push(text.slice(last));
  }

  return nodes.length ? nodes : [text];
}

function mentionLink(username, onnavigate) {
  return (
    <a
      className="StoryMention"
      href={app.route('user', {username})}
      onclick={(e) => {
        // Plain clicks route inside the app; modified clicks (new tab, etc.)
        // are left to the browser.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

        e.preventDefault();

        if (onnavigate) onnavigate();

        m.route.set(app.route('user', {username}));
      }}
    >
      @{username}
    </a>
  );
}
